import { getQualification, postQualification } from '@/api/api';

export default {
  computed: {
    student() {
      if (this.$store.getters.profile.role === 'STUDENT') {
        return this.$store.getters.profile;
      } else return this.$store.getters.student;
    },
    isTeacher() {
      return this.$store.getters.profile.role === 'TEACHER';
    }
  },
  methods: {
    async qualify() {
      if (!this.qualification.uuid && this.qualification.student) {
        const response = await postQualification(this.qualification);
        if (response) {
          return response.data;
        }
      } else return this.qualification;
    },
    async fetchQualification(student__email, question_group__uuid) {
      const response = await getQualification({
        student__email,
        question_group__uuid
      });
      if (response.data.count) {
        return response.data.results[0];
      } else {
        return {
          student: student__email,
          question_group: question_group__uuid
        };
      }
    }
  }
};
